<section class="main-content wrapper content-padding">
    <div class="content-panel">

        <div class="tabs">
            <label class="tab" *ngIf="!partnerStripeCard?.id">
                <a
                class="tab-link"
                routerLink="/partner/cards/nuovo"
                routerLinkActive="active-tab"
                >
                NUOVO CARTE
                </a>
            </label>
            <label class="tab" *ngIf="partnerStripeCard?.id">
                <a
                class="tab-link"
                [routerLink]="['/partner/cards/edit', partnerStripeCard?.id]"
                routerLinkActive="active-tab"
                >
                MODIFICA CARTE
                </a>
            </label>
        </div>

        <div class="heading">
            <div class="button-wrapper">
                <button class="btn hvr-grow has-margin-right" routerLink="/partner/cards"> 
                    CARTE<i class="ml-10 fas fa-credit-card"></i>
                </button>
            </div>
        </div>

        <section id="schedaPartner" class="content-padding ">
            <div class="narrow-wrapper">
                <form class="has-cols" [formGroup]="partnerStripeCartForm" (ngSubmit)="onSubmit()" *ngIf="partnerStripeCartForm">
                    <div class="">
                        <fieldset>
                            <legend>CARTE INFORMAZIONI</legend>
                            <div class="col-48 grid-element">
                                <label>Partner</label>
                                <select 
                                    formControlName="partner"
                                    *ngIf="loggedInPartner && groups.includes('partner')"
                                >
                                    <option 
                                        *ngFor="let partner of partners" 
                                        [value]="partner.id"
                                        [selected]="loggedInPartner && loggedInPartner.id == partner.id"
                                    >
                                        {{ partner.businessName }}
                                    </option>
                                </select>
                                <select 
                                    id="selezionePartner"
                                    formControlName="partner"
                                    *ngIf="!loggedInPartner && !groups.includes('partner')"
                                >
                                    <option disabled></option>
                                    <option 
                                        *ngFor="let partner of partners" 
                                        [value]="partner.id"
                                    >
                                        {{ partner.businessName }}
                                    </option>
                                </select>
                                <app-error-html-handler [ctrl]="partnerStripeCartForm.get('partner')" [messages]="formValidationMsgs.partner"></app-error-html-handler>
                            </div> 

                            <br class="clear">
                            <br class="clear">

                            <div class="grid-element-full">
                                <div id="card-element"></div>
                            </div>

                            <br class="clear">
                            
                            <div class="center">
                                <button 
                                    class="btn hvr-shrink center" 
                                    (click)="$event.preventDefault(); onSubmit()" 
                                    [disabled]="!partnerStripeCartForm?.valid || btnDisabled" 
                                >
                                Salva<i class="ml-10 far fa-save"></i>
                                </button>
                            </div>
                                
                        </fieldset>
                    </div>
                </form>
            </div>
        </section>

    </div>
</section>
